import React from 'react'

const Main = ({children}) => {
  return (
    <main style={{ paddingTop: "0px" }}>{children}</main>
  )
}

export default Main
